import { takeLatest, put, call, all, select } from 'redux-saga/effects';
import { getTrackerListWithAccessDetails } from '@api/tracker';
import {
  fetchTrackerListWithAccessDetails,
  fetchTrackerListWithAccessDetailsSucceed,
  fetchTrackerListWithAccessDetailsFailed,
  getTrackerState,
} from '@redux/ducks/tracker/tracker';
import {
  enableSelectedTrackers,
  disableSelectedTrackers,
  enableApplyAppPermissions,
  getUserPermissionsState,
} from '@redux/ducks/userPermissions/userPermissions';

// Workers

export function* fetchTrackerListTask() {
  try {
    const { searchTerm } = yield select(getTrackerState);
    const { currentApp } = yield select(getUserPermissionsState);

    const response = yield call(getTrackerListWithAccessDetails, {
      appToken: currentApp.token,
      access: currentApp.access,
      search: searchTerm,
    });

    yield put(fetchTrackerListWithAccessDetailsSucceed(response));
  } catch (error) {
    yield put(fetchTrackerListWithAccessDetailsFailed(error));
  }
}

export function* enableApplyAppPermissionsTask() {
  yield put(enableApplyAppPermissions());
}

// Watchers

export function* watchFetchTrackerList() {
  yield takeLatest([fetchTrackerListWithAccessDetails], fetchTrackerListTask);
}

export function* watchFormChange() {
  yield takeLatest([enableSelectedTrackers, disableSelectedTrackers], enableApplyAppPermissionsTask);
}

// Saga

export default function* trackerSaga() {
  yield all([watchFetchTrackerList(), watchFormChange()]);
}
